export default __webpack_public_path__ + "static/media/mod03.3cc0540e.svg";